import { CircleCheckBig, Upload } from "lucide-react";
import { useState } from "react";

function CustomizationPage() {
  // ---- State ----
  const [kurtiType, setKurtiType] = useState(""); // "short" ya "long"
  const [designMessage, setDesignMessage] = useState("");
  const [size, setSize] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  // ---- Image Upload Handler ----
  function handleImageChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);

    // Preview ke liye URL banana
    const previewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(previewUrl);
  }

  // ---- Simple Validation ----
  function validateForm() {
    const newErrors = {};

    if (!kurtiType) {
      newErrors.kurtiType = "Please kurti type select karein.";
    }
    if (!designMessage.trim()) {
      newErrors.designMessage = "Design preference batayein please.";
    }
    if (!size) {
      newErrors.size = "Size select karein please.";
    }

    setErrors(newErrors);

    // Agar koi error nahi hai toh true return karo
    return Object.keys(newErrors).length === 0;
  }

  // ---- Form Submit Handler ----
  function handleSubmit() {
    const isValid = validateForm();
    if (!isValid) return;

    // Yahan API call hogi — abhi sirf success show kar rahe hain
    console.log("Submitting:", { kurtiType, designMessage, size, imageFile });
    setIsSubmitted(true);
  }

  // ---- Reset Form ----
  function handleReset() {
    setKurtiType("");
    setDesignMessage("");
    setSize("");
    setImageFile(null);
    setImagePreviewUrl("");
    setErrors({});
    setIsSubmitted(false);
  }

  // ---- Success Screen ----
  if (isSubmitted) {
    return (
      <div className="customization-page">
        <div className="customization-success-card">
          <div className="customization-success-icon">
            <CircleCheckBig size={40} className="text-success" />
          </div>
          <h2 className="customization-success-title">Request Sent!</h2>
          <p className="customization-success-desc">
            Soon we will contact you to discuss your design and bring it to
            life. Thank you for choosing us to create your unique kurti!
          </p>
          <button className="customization-btn-secondary" onClick={handleReset}>
            New Request
          </button>
        </div>
      </div>
    );
  }

  // ---- Main Form ----
  return (
    <div className="customization-page">
      <div className="container">
        {/* Page Header */}
        <div className="row">
          <div className="col-5">
            <div className="customization-left-cont">
              <div className="customization-page-img-wrapper">
                <img src="/images/cst-img-01.png" alt="elegant kurti" />
              </div>
              <div className="customization-page-img-wrapper">
                <img src="/images/cst-img-02.png" alt="elegant kurti" />
              </div>
            </div>
          </div>
          <div className="col-7">
            <div className="customization-right-cont">
              <div className="customization-page-header">
                <h1 className="customization-page-title">Design Your Kurti</h1>
                <p className="customization-page-subtitle">
                  Share your vision with us, and we'll bring it to life exactly
                  as you imagine
                </p>
                <div className="customization-title-divider" />
              </div>

              {/* ===== STEP 1: Kurti Type ===== */}
              <div className="customization-form-card">
                <p className="customization-step-label">Step 1 — Kurti Type</p>

                <div className="customization-kurti-options">
                  <div
                    className={`customization-kurti-option ${kurtiType === "short" ? "selected" : ""}`}
                    onClick={() => setKurtiType("short")}
                  >
                    {/* <span className="customization-kurti-icon">👘</span> */}
                    <span className="customization-kurti-name">
                      Short Kurti
                    </span>
                    <span className="customization-kurti-desc">
                      Hip length · Casual wear
                    </span>
                  </div>

                  <div
                    className={`customization-kurti-option ${kurtiType === "long" ? "selected" : ""}`}
                    onClick={() => setKurtiType("long")}
                  >
                    {/* <span className="customization-kurti-icon">🥻</span> */}
                    <span className="customization-kurti-name">Long Kurti</span>
                    <span className="customization-kurti-desc">
                      Knee to ankle · Festive look
                    </span>
                  </div>
                </div>

                {errors.kurtiType && (
                  <p className="customization-error-text">{errors.kurtiType}</p>
                )}
              </div>

              {/* ===== STEP 2: Image Upload ===== */}

              <div className="customization-form-card">
                <p className="customization-step-label">
                  Step 2 — Reference Image
                </p>

                <label
                  className="customization-upload-box"
                  htmlFor="imageInput"
                >
                  {imagePreviewUrl ? (
                    /* Image upload ho gayi — preview dikhao */
                    <div className="customization-upload-preview-wrapper">
                      <img
                        src={imagePreviewUrl}
                        alt="Uploaded preview"
                        className="customization-upload-preview-img"
                      />
                      <p className="customization-upload-file-name">
                        ✓ {imageFile.name}
                      </p>
                    </div>
                  ) : (
                    /* Default upload UI */
                    <>
                      <span className="customization-upload-icon">
                        <Upload />
                      </span>
                      <p className="customization-upload-text">
                        Upload your design reference or inspiration image.
                      </p>
                      <p className="customization-upload-hint">
                        JPG, PNG, WEBP · Max 5MB
                      </p>
                    </>
                  )}
                </label>

                {/* Input hidden hai — label click pe trigger hoga */}
                <input
                  type="file"
                  id="imageInput"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="customization-hidden-input"
                />
              </div>

              {/* ===== STEP 3: Design Preference ===== */}
              <div className="customization-form-card">
                <p className="customization-step-label">
                  Step 3 — Design Preference
                </p>

                <label
                  className="customization-form-label"
                  htmlFor="designMessage"
                >
                  Share your vision with us
                </label>
                <span className="customization-form-hint">
                  For example: "I want a gota patti border, in light pink color,
                  sleeveless"
                </span>

                <textarea
                  id="designMessage"
                  className="customization-form-textarea"
                  placeholder="Describe your design idea here..."
                  maxLength={500}
                  value={designMessage}
                  onChange={(e) => setDesignMessage(e.target.value)}
                />

                <div className="customization-char-counter">
                  {designMessage.length}/500
                </div>

                {errors.designMessage && (
                  <p className="customization-error-text">
                    {errors.designMessage}
                  </p>
                )}
              </div>

              {/* ===== STEP 4: Size Preference ===== */}
              <div className="customization-form-card">
                <p className="customization-step-label">
                  Step 4 — Size Preference
                </p>

                <label
                  className="customization-form-label"
                  htmlFor="sizeSelect"
                >
                  Please select your size or choose custom size for a
                  personalized fit
                </label>

                <select
                  id="sizeSelect"
                  className="customization-form-select"
                  value={size}
                  onChange={(e) => setSize(e.target.value)}
                >
                  <option value="">-- Select Size --</option>
                  <option value="xs">XS · 32</option>
                  <option value="s">S · 34</option>
                  <option value="m">M · 36</option>
                  <option value="l">L · 38</option>
                  <option value="xl">XL · 40</option>
                  <option value="xxl">XXL · 42</option>
                </select>

                {errors.size && (
                  <p className="customization-error-text">{errors.size}</p>
                )}
              </div>

              {/* ===== Submit Button ===== */}
              <div className="customization-btn-container">
                <button
                  className="customization-btn-primary"
                  onClick={handleSubmit}
                >
                  Submit Customization Request →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomizationPage;
